exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".top[data-v-4a9c449c]{position:fixed;right:2rem;bottom:2rem;z-index:1000;background:#fff;border-radius:4px;width:40px;height:40px;box-shadow:0 1px 3px rgba(26,26,26,0.1);color:#8590a6;padding:0}button[data-v-4a9c449c]:hover,button[data-v-4a9c449c]:focus{outline:none}\n", ""]);

